
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { VERSION } from "./version";

export const environment = {
  production: false,
  endpoint: 'http://13.65.139.59:8081/MKTPlace2/rest/',
  //endpoint: 'http://localhost:8081/MKTPlace2/rest/',
  versionApp: VERSION.version + " - "+VERSION.raw,
  enableCrypto: false,
};

